"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
exports.config = {
    ids: {
        '1': 'bc280b59-5ec8-11ea-8091-0242ac130002',
        '2': '3bda6a4c-2c73-49ed-a93a-5974c16ae94f',
        '3': '84a06d3b-8b1b-11eb-bb13-0abd40aed1a0',
        '4': 'a1380df6-8b1b-11eb-bb13-0abd40aed1a0',
        '7': '8c68d842-458d-41be-af0b-b870a0817ba8',
        '66': 'bd09f3d1-8b1b-11eb-bb13-0abd40aed1a0',
        '69': 'db246b95-8b1b-11eb-bb13-0abd40aed1a0',
        '70': 'f352b2ab-998d-4aef-8193-e4aa7f5ec004',
        '71': 'c77fbff4-4b34-4a77-bfea-66d97b0cee6f',
        '73': '4712c50e-f1cc-4868-a778-5916dd4ff10e',
        '76': 'b9427981-99b1-4388-95d8-619d90789c68',
    },
};
